export enum GroupStatusType {
  Unknown = 0,
  OutOfService = 1,
  Open = 2,
  Archived = 3
}